import { apiClient } from "./apiClient";
export const systemsApi = {
    list: () => apiClient.get("/systems"),
    get: (id) => apiClient.get(`/systems/${id}`),
    history: (id, take = 100) => apiClient.get(`/systems/${id}/history?take=${take}`),
    create: (payload) => apiClient.post("/systems", payload),
    update: (id, payload) => apiClient.put(`/systems/${id}`, payload),
    remove: (id) => apiClient.delete(`/systems/${id}`),
    checkNow: (id) => apiClient.post(`/systems/${id}/check`),
    checkKomodoNow: (id) => apiClient.post(`/systems/${id}/check-komodo`),
};
